export { default } from './AdjustmentsTable';
